import { render, staticRenderFns } from "./RevisitPage.vue?vue&type=template&id=67b2b7d2"
import script from "./RevisitPage.vue?vue&type=script&lang=js"
export * from "./RevisitPage.vue?vue&type=script&lang=js"
import style0 from "./RevisitPage.vue?vue&type=style&index=0&id=67b2b7d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports